import React from 'react';
import { Modal } from 'react-bootstrap';

import FittingOrdererListContainer from '../containers/FittingOrdererListContainer.jsx';
import FittingOrdererEditContainer from '../containers/FittingOrdererEditContainer.jsx';

export default class FittingOrderersComponent extends React.Component {

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <FittingOrdererListContainer orderId={this.props.orderId} />
        <Modal show={this.props.showFittingOrdererModal} onHide={this.props.closeModal} backdrop="static">
          <Modal.Header closeButton />
          <Modal.Body>
            <FittingOrdererEditContainer />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/FittingOrderersComponent.jsx